export const Marquee = () => {
  const text = "KCI REGISTERED  ✦  GOVT CERTIFIED  ✦  BVSc VET SUPPORTED  ✦  LIFETIME VACCINATION REMINDERS  ✦  ";

  return (
    <div className="relative bg-[#E5ECD9] border-y border-[#DCD7CE] py-6 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...Array(4)].map((_, i) => (
          <span
            key={i}
            className="font-display italic text-xl md:text-2xl text-[#0F2520] mr-4"
          >
            {text}
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
          width: max-content;
        }
      `}</style>
    </div>
  );
};
